<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="isOpen()" *ngIf="isOpen()" (click)="close()"></div>

<!-- Modal Dialog -->
<div class="modal fade" [class.show]="isOpen()" [class.d-block]="isOpen()" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bi bi-geo-alt-fill text-primary me-2"></i>
            Quick Add Field
          </h5>
          <button type="button" class="btn-close" (click)="close()"></button>
        </div>

        <div class="modal-body">
          <div class="row g-3">
            <!-- Customer Selection -->
            <div class="col-12" *ngIf="customerOptions.length > 0">
              <label class="form-label d-flex align-items-center gap-2">
                <i class="bi bi-person text-muted"></i>
                Customer
                <span class="badge bg-secondary-subtle text-secondary">Optional</span>
              </label>
              <select class="form-select" formControlName="customerId">
                <option value="">No customer (unassigned)</option>
                <option *ngFor="let customer of customerOptions" [value]="customer.id">{{ customer.name }}</option>
              </select>
            </div>

            <div class="col-12">
              <label class="form-label">Field Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="name"
                     placeholder="e.g., North Field - Section A"
                     [class.is-invalid]="isFieldInvalid('name')">
              <div class="invalid-feedback">Please enter a field name</div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Acreage <span class="text-danger">*</span></label>
              <div class="input-group">
                <input type="number" class="form-control" formControlName="acreage"
                       placeholder="45.5" step="0.1" min="0.1"
                       [class.is-invalid]="isFieldInvalid('acreage')">
                <span class="input-group-text">ac</span>
              </div>
              <div class="invalid-feedback">Please enter a valid acreage</div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Crop Type <span class="text-danger">*</span></label>
              <select class="form-select" formControlName="cropType"
                      [class.is-invalid]="isFieldInvalid('cropType')">
                <option value="">Select crop...</option>
                <option *ngFor="let crop of cropTypes" [value]="crop">{{ crop }}</option>
              </select>
              <div class="invalid-feedback">Please select a crop type</div>
            </div>

            @if (isOtherCropType) {
              <div class="col-12">
                <label class="form-label">Specify Crop Type <span class="text-danger">*</span></label>
                <input type="text" class="form-control" formControlName="customCropType"
                       placeholder="e.g., Sunflowers, Hemp, Pecans"
                       maxlength="100"
                       [class.is-invalid]="isFieldInvalid('customCropType')">
                <div class="invalid-feedback">Please specify the crop type</div>
              </div>
            }

            <div class="col-12">
              <hr class="my-2">
              <label class="form-label d-flex align-items-center gap-2">
                <i class="bi bi-pin-map text-muted"></i>
                GPS Coordinates
                <span class="badge bg-secondary-subtle text-secondary">Optional</span>
              </label>
            </div>

            <div class="col-md-6">
              <input type="number" class="form-control" formControlName="latitude"
                     placeholder="Latitude (e.g., 32.7767)" step="0.000001"
                     [class.is-invalid]="isFieldInvalid('latitude')">
              <div class="invalid-feedback">Latitude must be between -90 and 90</div>
            </div>

            <div class="col-md-6">
              <input type="number" class="form-control" formControlName="longitude"
                     placeholder="Longitude (e.g., -96.7970)" step="0.000001"
                     [class.is-invalid]="isFieldInvalid('longitude')">
              <div class="invalid-feedback">Longitude must be between -180 and 180</div>
            </div>
          </div>

          <div class="form-text mt-3">
            <i class="bi bi-info-circle me-1"></i>
            GPS coordinates enable weather lookup. You can add more details later in the Fields management page.
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="close()">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="isSaving()">
            <ng-container *ngIf="!isSaving()">
              <i class="bi bi-plus-lg me-1"></i>Add Field
            </ng-container>
            <ng-container *ngIf="isSaving()">
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
              Adding...
            </ng-container>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
